import { convert } from '../utils'

let lines = [


  {text:['蒙特雷湾水族馆'],startTime:'00:00:01.00', endTime:'00:00:02.79'},
  {text:['是世界上超大的水族馆之一'],startTime:'00:00:02.80', endTime:'00:00:05.38'},
  {text:['你一定想不到'],startTime:'00:00:05.39', endTime:'00:00:06.60'},
  {text:['这里竟改造于20世纪初的罐头厂'],startTime:'00:00:06.61', endTime:'00:00:09.71'},
  {text:['其规模之大令人震撼'],startTime:'00:00:09.72', endTime:'00:00:11.87'},
  {text:['巨型玻璃水箱里'],startTime:'00:00:11.88', endTime:'00:00:13.75'},
  {text:['拥有超过35000只','代表550个物种的动植物'],startTime:'00:00:13.76', endTime:'00:00:18.27'},
  {text:['尤其是罕见的加州本地物种'],startTime:'00:00:18.28', endTime:'00:00:21.52'},
  {text:['除了必看的水母和蝠鲼'],startTime:'00:00:21.52', endTime:'00:00:24.12'},
  {text:['还有精彩纷呈的水下体验'],startTime:'00:00:24.13', endTime:'00:00:26.91'},
  {text:['让你仿佛置身于真正的海洋里一样'],startTime:'00:00:26.92', endTime:'00:00:30.21'},


]

export default convert(lines)
